<template>
    <div class="lang-selector">
        <div v-for="language in existingLanguages" class="challenge-group-languages-wrapper"
             @click="selectLanguage(language)">
            <div class="challenge-group-languages" :key="language.id" :id="language.key"
                 :class="{
                                    'bg-python': language.key === 'python' && language.selected,
                                    'bg-dockerfile': language.key === 'dockerfile' && language.selected,
                                    'bg-java': language.key === 'java' && language.selected,
                                    'bg-javascript': language.key === 'javascript' && language.selected,
                                    'bg-csharp': language.key === 'csharp' && language.selected,
                                    'bg-cpp': language.key === 'cpp' && language.selected,
                                    'bg-php': language.key === 'php' && language.selected,
                                    'bg-abap': language.key === 'abap' && language.selected,
                                    'bg-kotlin': language.key === 'kotlin' && language.selected,
                                    'bg-powershell': language.key === 'bg-powershell' && language.selected,
                                    'bg-rust': language.key === 'rust' && language.selected,
                                    'inactive': !language.selected,
                                    'isNotMobile': !isMobile(),
                                }">
                <i class="dev-icon dev-code-slash"></i>
                <span class="technology-label">{{getLanguageName(language.key).toUpperCase()}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {LANGUAGES} from "../../const";
    import {eventBus} from "../../main";

    export default {
        name: "LanguageFilter",
        props: {
            allChallengesCheckbox: {type: Boolean, default: false},
            languagesRetrievedFromApi: {type: Set, default: () => {}},
        },
        data() {
            return {
                languages: [
                    {id: "lang1", key: "cpp", selected: false},
                    {id: "lang2", key: "csharp", selected: false},
                    {id: "lang3", key: "java", selected: false},
                    {id: "lang4", key: "javascript", selected: false},
                    {id: "lang5", key: "php", selected: false},
                    {id: "lang6", key: "python", selected: false},
                    {id: "lang7", key: "dockerfile", selected: false},
                    {id: "lang8", key: "abap", selected: false},
                    {id: "lang9", key: "kotlin", selected: false},
                    {id: "lang10", key: "powershell", selected: false},
                    {id: "lang11", key: "rust", selected: false},
                ],
                showAll: false,
            }
        },
        mounted() {
            if (typeof this.$route.query !== "undefined" && this.$route.query.hasOwnProperty("languageFilter")) {
            let filter = this.$route.query.languageFilter;
            let filterList = filter.split(",");
            for (let filterLanguage of filterList) {
              for (let givenLanguage of this.languages) {
                if (givenLanguage.key === filterLanguage.toLowerCase()) {
                  givenLanguage.selected = true;
                }
              }
            }
            this.$emit('selectLanguages', this.languages);
          }
        },
        methods: {
            resetFilters: function () {
              for (let language of this.languages) {
                language.selected = false;
              }
            },
            getLanguageName(languageKey) {
                return LANGUAGES[languageKey];
            },
            selectLanguage(selectedLanguage) {
                selectedLanguage.selected = !selectedLanguage.selected;
                this.$emit('selectLanguages', this.languages);
            },
            toggleShowAll() {
                this.showAll = !this.showAll;
                this.$emit('showAll', this.showAll);
            },
            isMobile: function () {
                return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            },
        },
        computed: {
            existingLanguages: function() {
                return this.languages.filter(language =>
                    this.languagesRetrievedFromApi.has(language.key)
                );
            },
        },
    }
</script>

<style scoped>
    .lang-selector {
        padding-bottom: 0.8rem;
        padding-left: 2rem;
        display:flex;
        justify-content: flex-end;
        margin-top: 36px;
    }

    @media (max-width: 1200px) {
        .lang-selector {
            display: block;
            text-align: center;
        }
    }

    .challenge-group-languages-wrapper {
        position: relative;
        display: inline-block;
    }

    .challenge-group-languages {
        font-family: "Source Code Pro", sans-serif;
        color: white;
        overflow: hidden;
        padding: 3px 20px;
        margin-bottom: 2px;
        border-radius: 100px;
        background-color: grey;
        margin-right: 1rem;
        line-height: 1.6;
        -webkit-transform: perspective(1px) translateZ(0);
        transform: perspective(1px) translateZ(0);
        box-shadow: 0 3px 8px rgba(13, 51, 85, 0.2);
        -webkit-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -webkit-transition-property: box-shadow, transform;
        transition-property: box-shadow, transform;
        -ms-user-select: None;
        -moz-user-select: None;
        -webkit-user-select: None;
        user-select: None;
    }

    .challenge-group-languages > .dev-icon {
        position: absolute;
        bottom: -20%;
        left: -8%;
        font-size: 28px;
        color: rgba(255, 255, 255, 0.15);
    }

    .technology-label {
        font-size: 11px;
    }

    .isNotMobile.challenge-group-languages:hover {
        cursor: pointer;
        box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .inactive {
        background-color: white !important;
        color: #08AB99 !important;
    }
</style>